import * as React from 'react';

export const PerformanceEvaluationTab = () => {
  return <div>TBA tab content: PerformanceEvaluationTab</div>;
};
